import { useQuery } from "@tanstack/react-query";
import { shippingInfosQueryApi } from "@/shared/api/shipping-infos/query";
import { ShippingInfoResponse } from "@/shared/api/shipping-infos/types";
import useCompanyIdentity from "@/shared/hooks/useCompanyIdentity";
import { toCamelKeyObject } from "@/utils/case";

// 바이어의 배송지 목록 조회 훅 — 바이어 페이지에서는 companyId가 buyer_id다.
// 대행(에이전시)에서 특정 바이어의 배송지를 봐야 하면 buyerId를 명시한다.
// 비suspense 쿼리로 둔 이유: 이 훅을 쓰는 모달이 로딩·결과없음 화면을 직접 그린다.
// 모달 안에서 suspense가 throw되면 모달을 감싼 트리까지 함께 날아간다.
const useGetShippingInfos = (buyerId?: number) => {
  const { companyId } = useCompanyIdentity();
  const targetBuyerId = buyerId ?? companyId;

  const { data: shippingInfos, isPending } = useQuery({
    queryKey: ["shipping-infos", targetBuyerId],
    queryFn: () =>
      shippingInfosQueryApi.getShippingInfos(targetBuyerId as number),
    select: (data) => toCamelKeyObject(data) as ShippingInfoResponse[],
    enabled: Boolean(targetBuyerId),
  });

  return { shippingInfos, isPending };
};

export default useGetShippingInfos;
